<div class="or-p-16-px or-pt-40-px or-bg-shade">
  <div class="or-head-xs or-color-secondary-2 or-mb-12-px">Zarządzaj gierką</div>

  @if (isAdmin()) {
    <div
      (click)="generateReassignUrl()"
      class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
      <or-icon name="copy-link" size="s" boxed class="or-mr-8-px" />
      <div class="or-text-md">Generuj reassign URL</div>
    </div>
  }
  @if (!isPlayerInGame) {
    <div
      [sendApplication]="game.gameId"
      [showModal]="false"
      class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
      <or-icon name="profile" size="s" boxed class="or-mr-8-px" />
      <div class="or-text-md">Dołącz do gierki jako gracz</div>
    </div>
  }

  <div
    (click)="addPlayer()"
    class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
    <or-icon name="plus" size="s" boxed class="or-mr-8-px" />
    <div class="or-text-md">Dodaj gracza ręcznie</div>
  </div>

  <div
    (click)="changeVisibility()"
    class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
    <or-icon name="location" size="s" boxed class="or-mr-8-px" />

    <div>
      <div class="or-text-md">{{ visibilityLabel.header }}</div>
      <div class="or-text-sm or-color-secondary-2">{{ visibilityLabel.text }}</div>
    </div>
  </div>

  <div
    (click)="goToInvitations()"
    class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
    <or-icon name="notifications" size="s" boxed class="or-mr-8-px" />
    <div class="or-text-md">Zaproś dawnych graczy</div>
  </div>

  <div
    (click)="goToLineups()"
    class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
    <or-icon name="randomize" size="s" boxed class="or-mr-8-px" />
    <div class="or-text-md">Losuj składy</div>
  </div>

  <div
    (click)="editGame()"
    class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-mb-8-px or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
    <or-icon name="edit-game" size="s" boxed class="or-mr-8-px" />
    <div class="or-text-md">Edytuj gierkę</div>
  </div>

  <div
    (click)="removeGame()"
    class="or-cursor-pointer border-radius-4 border-shade or-align-items-center or-bg-white or-d-flex or-p-8-px or-h-56-px or-max-h-28-px">
    <or-icon name="trash" size="s" boxed class="or-mr-8-px" />
    <div class="or-text-md or-color-red">Usuń gierkę</div>
  </div>
</div>
